import TagManager from 'react-gtm-module';

import { isDesktop } from './functions';

import { ResponseRegisterSuccess } from '@/types';

/**
 * Sólo al final de una registración exitosa.
 * @param data
 */
export const enviarEventoFinRegistracion = (data: ResponseRegisterSuccess) => {
  if (
    !data.modoRegistracion ||
    data.modoRegistracion === 'NO_ES_REGISTRACION'
  ) {
    return;
  }
  TagManager.dataLayer({
    dataLayer: {
      event: 'registracion',
      cd_paseId: data.auth0_id,
      modo: data.modoRegistracion,
      usuario: data.premium ? 'Premium' : 'Normal',
    },
  });
};

export type CustomizedInitialEvent = {
  usuario: 'Premium' | 'Normal' | '-2'; // -2 ?
  cdSexo: 'm' | 'f' | 'otro' | '-2'; // -2 ?
  // dataSource: 'app' | 'web';
  edadDt: number | undefined;
  paseId: string | undefined;
  modo: string | undefined;
};

/**
 * Evento inicial.
 * <br>
 * Luego de cada autenticación exitosa (callback)
 * <br>
 * Dos acciones:
 * - si es registración (primer login), envía evento de registración
 * - si no es registración, completa los datos del usuario en el objeto dataLayer
 *   (sospecho que acá lo importante es llenar eso, y que realmente no se traquea un pageview en GA)
 * <br>
 * @param data parámetro armado a mano en Authenticated.tsx
 */
export const enviarEvento = (data: CustomizedInitialEvent) => {
  /*
  Posibles bugs por revisar: 
    - "-2" es un valor sospechoso de paseId y usuario. Supongo que el llamado desde 'Login.tsx' 
      es excluyente con el callback de Auth0. Pero, ¿ese -2 está hablado?
    - si es registración automática (primer login de la edición, sin pedir datos extra), 
      no se completa el dataLayer con los datos del usuario. ¿Es intencional?
    - en dataSource, envía "app" para un navegador mobile. ¿Es intencional? Yo usaría "isAndroid()"
      Si es así, documentar que "app" no significa "app nativa".
    - cuando es Android NUNCA puedo traquear una registración, seba Gallardo nunca podría encontrar ese valor.
          ¿Es intencional? Ese tracking está en otro property. 
          En ese caso, ver si la app me tiene que enviar alguna señal para volver a traquear esto.
  */

  // FIX: "_action=datos" (android) devuelve "modo" undefined
  const modoReg = data.modo || 'NO_ES_REGISTRACION';
  // si es registración, envía evento de registración
  if (modoReg !== 'NO_ES_REGISTRACION') {
    log('registración, tracking gtm dataLayer');
    TagManager.dataLayer({
      dataLayer: {
        event: 'registracion',
        ID: data.paseId,
        modo: modoReg,
      },
    });
  } else if (modoReg === 'NO_ES_REGISTRACION') {
    // completa los datos del usuario en el objeto dataLayer
    log(
      `no es registración, completo dataLayer con datos de usuario ${
        data.paseId ?? '-2'
      }`
    );
    TagManager.dataLayer({
      dataLayer: {
        event: 'sendPageView',
        cd_paseId: data.paseId,
        cd_nsSite: 'grandt',
        cd_edad: data.edadDt,
        cd_tipoPagina: 'Home',
        dataSource: !isDesktop() ? 'app' : 'web',
        cd_sexo: data.cdSexo,
        usuario: data.usuario,
      },
    });
  }
};

export const enviarEventoVerificacionNombre = (
  motivo: 'coincidenciaBaja' | 'cuilNoEncontrado' | 'corregido'
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'verificacionNombreDni',
      motivo,
    },
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function log(_msg: string) {
  // eslint-disable-next-line no-console
  // console.log(msg);
}
